import { createSlice } from '@reduxjs/toolkit'
import {
  addComment,
  deleteComment,
  getCommentbyId,
  getCommentsByActionId,
  updateComment,
} from './commentActions'
import { Comment } from '../../types/commentTypes'

interface CommentState {
  comments: Comment[]
  loading: boolean
  comment: Comment | null
  error: string | null
  addedComment: Comment | null
  updatedComment: Comment | null
}

const initialState: CommentState = {
  comments: [],
  loading: false,
  error: null,
  addedComment: null,
  comment: null,
  updatedComment: null,
}

export const commentSlice = createSlice({
  name: 'comment',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(deleteComment.fulfilled, (state, action) => {
        state.loading = false
        const deletedCommentId = action.meta.arg

        if (state.comments) {
          state.comments = (state.comments ?? []).filter(
            (comment) => comment._id !== deletedCommentId
          )
        }
      })
      .addCase(addComment.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(addComment.fulfilled, (state, action) => {
        state.loading = false
        state.addedComment = action.payload
        if (Array.isArray(state.comments)) {
          state.comments.push(action.payload)
        } else {
          state.comments = [action.payload] // If it's not an array, initialize it as one
        }
      })
      .addCase(addComment.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Something went wrong'
      })
      .addCase(updateComment.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(updateComment.fulfilled, (state, action) => {
        state.loading = false
        state.updatedComment = action.payload
      })
      .addCase(updateComment.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Something went wrong'
      })
      .addCase(getCommentbyId.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(getCommentbyId.fulfilled, (state, action) => {
        state.loading = false
        state.comment = action.payload
      })
      .addCase(getCommentbyId.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Something went wrong'
      })
      .addCase(getCommentsByActionId.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(getCommentsByActionId.fulfilled, (state, action) => {
        state.loading = false

        const commentsData = action.payload
        const comments = Object.values(commentsData).filter(
          (item) => typeof item === 'object' && '_id' in item
        ) as Comment[]
        state.comments = comments
      })
      .addCase(getCommentsByActionId.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Something went wrong'
      })
  },
})

export default commentSlice.reducer
